import classNames from 'classnames';
import React, {memo, PropsWithChildren, ReactNode} from 'react';
import style from './style.module.scss';
import {TTypographyVariant, Typography} from 'components/Typography';
import {TPropsWithClassName} from 'core/types';
import {TShieldColor, TShieldSize} from './constants';
import {Tooltip} from 'components/Tooltip';
import Icon from 'components/Icon';

export interface IProps {
    backColor?: TShieldColor;
    isRating?: boolean;
    icon?: ReactNode;
    info?: string;
    size?: TShieldSize;
    customFontVariant?: TTypographyVariant;
}

const TYPOGRAPHY_VARIANT_BY_SIZE: Record<TShieldSize, TTypographyVariant> = {
    large: 'label-16-r',
    medium: 'label-12-r',
    small: 'label-12-r',
};

export const Shield = memo<PropsWithChildren<TPropsWithClassName<IProps>>>(function Shield({
    children,
    className,
    backColor = 'gray',
    isRating = false,
    icon,
    info = '',
    size = 'large',
    customFontVariant,
}) {
    return (
        <div
            className={classNames(style.shieldContainer, className, {
                [style[backColor]]: Boolean(backColor),
                [style[size]]: Boolean(size),
                [style.isOnlyIcon]: !children && Boolean(icon),
            })}
        >
            {Boolean(icon) && <div className={classNames(style.icon, 'shield-icon')}>{icon}</div>}
            {isRating && <Icon className={style.ratingIcon} icon={'star'} />}
            {children && (
                <Typography variant={customFontVariant ?? TYPOGRAPHY_VARIANT_BY_SIZE[size]}>{children}</Typography>
            )}
            {Boolean(info) && (
                <Tooltip childrenClassName={style.tooltipElement} overlay={info}>
                    <Icon className={style.infoIcon} icon={'question-sm'} />
                </Tooltip>
            )}
        </div>
    );
});
